import React from "react";
import styles from "./InviteFriend.module.css";
import { SubmitButton, TextComponent } from "../../../components";
import appstoreIcon from "../../../assets/appstore-icon.png";
import playstoreIcon from "../../../assets/playstore-icon.png";
import { Input } from "antd";
import { useDispatch } from "react-redux";
import { showAlert } from "../../../Store/Actions/GeneralActions";

const links = [
  {
    link: "www.Bestdayever.com/appstore/download",
    icon: appstoreIcon,
  },
  {
    link: "www.BesyDayEver.com/playstore/download",
    icon: playstoreIcon,
  },
];

const InviteFriend = () => {
  const dispatch = useDispatch();
  async function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return await navigator.clipboard.writeText(text);
    }
  }

  const handleCopyClick = (link) => {
    // Asynchronously call copyTextToClipboard
    copyTextToClipboard(link)
      .then(() => {
        // If successful, update the isCopied state value
        dispatch(showAlert({ type: "success", message: "Link Copied" }));
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className={styles.inviteFriendContainer}>
      <TextComponent
        textClass={styles.inviteFriendHeading}
        text={"Invite Friend"}
      />
      <TextComponent
        textClass={styles.inviteFriendSubHeading}
        text={
          "Share a Referral Link and Invite Your Friends to Download the app"
        }
      />
      {/* <div onClick={appstore} className={styles.invitelinkContainer}>
        <Input
          id="appstoreLink"
          readOnly
          value={"www.Bestdayever.com/appstore/download"}
        />
        <div className={styles.rightCont}>
          <img src={appstoreIcon} alt="App Store" />
          <SubmitButton title="Copy" btnClass={styles.btn} />
        </div>
      </div> */}
      {links.map((data) => (
        <div className={styles.invitelinkContainer}>
          <TextComponent text={data.link} textClass={styles.textClass} />
          <div className={styles.rightCont}>
            <img src={data.icon} alt="Play Store" />
            <SubmitButton
              title="Copy"
              btnClass={styles.btn}
              onClick={() => handleCopyClick(data.link)}
            />
          </div>
        </div>
      ))}
      <p id="copied"></p>
    </div>
  );
};

export default InviteFriend;
